export default "__VITE_ASSET__BgMA$tUp__"